import styled from "styled-components";

export const ManagementTeamWrapper = styled.div``